export const CommonComponents={
    "选择时间":"Select time",
    "不限制":"Unlimited",
    "不限":"Unlimited",
    "添加文件类型":"Add file type",
    "请输入文件类型":"Please enter the file type",
    "请选择文件类型":"Please select a file type",
    "确定要删除文件类型":"Confirm to delete file type",
    "删除后将不可恢复":"The deletion will not be recoverable",
    "设置满分条件":"Full score conditions",
    "满分条件":"Full score conditions",
    "回复":"reply",
    "条满分":" comments can earn full score",
    "选择小组批次":"Select group batch",
    "请选择小组批次":"Please select a group batch",
    "立即发布":"Publish Now",
    "请选择要发送的学生":"Please select the students to send",
    "暂时不支持视频播放":"Video playback is temporarily not supported",
    "暂时不支持音频播放":"Audio playback is temporarily not supported",
    "下载":"Download",
    "发送":"Send",
    "个附件":" Attachments",
    "上传":"upload",
    "外部浏览器打开":"External browser open",
    "点击下载":"Click Download",
    "由于微信浏览器本身的限制":"Note: Due to the limitation of WeChat browser itself, direct download is not allowed. Please follow the above figure, select a browser and download it in the browser",
    "答题卡":"Answer Sheet",
    "已完成":"Completed ",
    "数值":" figure",
    "正确答案":"correct answers",
    "我的答案":"My answer",
    "试题解析":"Answer analysis",
    "点击过快":"Click too fast, saving answers...",
    "请输入答案":"Please enter the answer",
    "参考答案":"Reference answer",
    "保存答题":"Save Answer",
    "对":"T",
    "错":"F",
    "如有描述":"If there is a description, please enter",
    "本题得分":"My Score",
    "分值":"Score ",
    "分":" ",
    "项":" item",
    "匿名":"anonymous",
    "实名":"real name",
    "难度":"difficulty",
    "第一题":"Question 1",
    "最后一题":"Last question",
    "下一题":"Next",
    "上一题":"Previous",
    difficulty:{
        "易":"easy",
        "中":"medium",
        "难":"hard",
    },
    SubjectType:{
        "判断题":"T or F",
        "单选题":"Single choice",
        "多选题":"Multiple choice",
        "简答题":"Short answer",
        "投票单选":"Vote single",
        "投票多选":"Vote for multiple choices",
        "数值评价题":"Numerical evaluation ",
        "匿名开放题":"Anonymous open-ended questions",
        "拍照题":"Photographic question",
        "段落说明题":"Paragraph Caption",
        "不定项选择题":"Indefinite choice question",
        "填空题":"Fill-in-the-blanks",
        "文件题":"File",  
    },
    Comment:{
        "实名发表":"Real name publication",
        "发表内容":"Contents",
    },
    "确认提交":"Confirm submission？",
    "提交之后将无法进行更改":"No changes can be made after submission",
    "全部题型":"All questions",
    "按题号排序":"Sort question number",
    "按得分率排序":"Sort by scoring rate",
    "人参与":"people",
    "人":" peoples",
    "得分率":"Score rate",
    "查看学生作答":"Students' answers",
    "确认要删除此错题吗":"Are you sure to delete this error",
    "删除后无法恢复":"Cannot recover after deletion!",
    "题号":"Title No",
    "查看试题答案及解析":"The answer and analysis of question",
    "暂无":"None",
    "人答题":" peoples",
    "展示词云":"Display word cloud",
    "学习中":"learning",
    "未学习":"Not learned",
    "已学习":"Completed",
    "学习状态":"Status",
    "请选择":"Please choose",
    "会议号":"Meeting number:",
    "会议密码":"Meeting password:",
    "会议时间":"Meeting time:",
    "搜索学生姓名学号":"Search student's name and ID",
    "发布时间":"Release time",
    Vipdg:{
        "是否开通会员":"Have a membership？",
        "非会员附件不能超过150M开通课堂派VIP可上传2G附件另外尊享更多VIP会员功能":"Nonmember cannot upload a file exceed 150M. VIP can upload 2G files and enjoy more VIP functions",
        "开通VIP":"Have a membership",
        "非VIP最多可创建50个课程包含删除和归档的课程您的课程已达到上限开通VIP可继续创建课程并且无上线另外VIP可尊享更多权益":'Non VIP can create up to 50 courses (including deleted and archived courses). Your courses have reached the upper limit. If you join VIP, you can continue to create courses without going online. In addition, VIP can enjoy more benefits',
        "您当时是学生VIP无法转换成老师身份如有特殊需要请联系客服进行修改":"You were a student VIP at that time and could not be converted to a teacher identity. If you have special needs, please contact the customer service for modification",
        "vip限时特惠":"Vip limited time special",
        "当前弹幕特效体验次数已用完开通vip畅享超酷弹幕特效和更多权益":"The current number of bullet screen effects has been used up. Join vip to enjoy cool bullet screen effects and more benefits!",
        "开通vip可继续使用弹幕效果是否开通vip":"You can continue to use the bullet screen effect after joining the vip. Do you want to join the vip?",
    },
    "读取中":"Reading...",
    "上传中":"Uploading...",
    "上传完成":"Upload completed",
    "此视频暂无法播放请稍后再试":"This video cannot be played temporarily. Please try again later",
    "该资源无法提供下载":"This resource cannot be downloaded!",
    "已经是第一页":"Already the first page",
    "已经是最后一页":"Already the last page",
    "确定要删除吗":"Are you sure to delete",
    "提醒":"Remind",
    "标题":"Title",
    "从备课区导入":"Preparation area",
    "从课程导入":"Course",
    "从慕课资源导入":"MOOC resources",
    "请输入内容":"Please enter the content",
    "人次学习":"study",
    "全部学校":"All schools",
    "全部专业":"All majors",
    "正在导入":"Importing...",
    "数字评价题":"Digital evaluation questions",
    "颜色选择":"Color Selection",
    "默认":"Default",
    "动画选择":"Animation selection",
    "弹幕动画预览":"Bullet screen animation preview",
    "无":"None",
    "立即参与":"Get involved now",
    "人发表意见":"people express their opinions",
    "查看":"View",
    "个名额共":"places,(",
    "个）":"in total",
    "暂无记录":"No record",
    "暂无内容发表第一条弹幕吧":"No content for the moment. Please publish the first bullet screen",
    "加入互动":"Join Interaction",
    "暂无互动试题":"No interactive questions",
    "老师已关闭弹幕":"The teacher has closed the bullet screen",
    "发言历史":"Speak History",
    "老师暂未开启直播课件同屏":"The teacher has not opened the live broadcast/courseware synchronization",
    "如未自动播放请点击播放":"If it is not automatically played, please click Play",
    "同屏中":"Synchronizing",
    "连接失败":"Connection failed",
    "刷新一下":"Refresh",
    "发言":"Speak",
    "弹幕记录":"Bullet screen record",
    "课堂记录":"Class record",
    "展开画面":"Expand the screen",
    "请答题":"Please answer the question",
    "历史发言":"Historical statements",
    "老师已开启抢答":"The teacher has started asking a question",
    "是否抢答":"Whether to rush to answer",
    "正在直播上课":"Living/Having class",
    "课堂已结束正在检查是否有互动和抢答":"The class is over! Checking whether there is interaction and quick answer",
    "抢答已结束":"Rush to answer has ended",
    "老师已禁止弹幕":"The teacher has forbidden the bullet screen",
    "发送成功":"Sending succeeded",
    "本次课堂已结束":"This class has ended",
    "老师已开启弹幕":"The teacher has opened the bullet screen",
    "老师已关闭同屏":"The teacher has closed courseware synchronization",
    "老师已开启同屏":"The teacher has opened courseware synchronization",
    "老师已关闭直播":"The teacher has closed the live",
    "老师发起了互动答题":"The teacher initiated an interactive answer",
    "是否参与答题":"Whether to answer questions",
    "加入":"Join",
    "已将疑问标记给老师":"The question mark has been displayed to the teacher",
    "已取消疑问":"The question mark has been canceled",
    "活动类型名称10字以内":"Name of activity type (within 10 words)",
    "新建活动内容":"Create Activity Content",
    "请输入活动名称":"Please enter the activity name",
    "课程达成度指标":"Course achievement index",
}